/**
 * The dashboard view model. There is no stored "dashboard" record: it is derived on read, exactly as the legacy
 * system did, from the employee's latest annual PmReview (`PmReview`), the completed reviewer tasks of that review
 * (`PmReviewDetail`, answered Likert forms), the synced financials (`QuantitativeData`) and the scoring weights
 * (`KpiConfiguration`). `utils/build-dashboard.ts` builds it; the widgets only render it.
 *
 * Not ported yet: the reviewer-participation breakdown, the three overlaid radar charts, the portfolio financials
 * table, and the "edit customer projects" flow that re-syncs financials from MBM (needs the MBM integration).
 */
export interface CategoryScore {
  Category: string;
  Score: number;
  MaxScore: number;
}

export interface QuantitativeMetric {
  Metric: string;
  Target: number;
  Actual: number;
  AchievementPercent: number;
  Score: number;
}

export interface ReviewerGroupScore {
  ReviewerGroup: string;
  CategoryScoresJson: string;
  WeightedAverage: number;
}

export interface PerformanceDashboard {
  ItemId: string;
  PmReviewId: string;
  UserId: string;
  EmployeeName: string;
  Designation?: string;
  DepartmentName?: string;
  ManagerName?: string;
  ReviewCycleLabel: string;
  FinalScore: number;
  QualitativeScore: number;
  QuantitativeScore: number;
  PerformanceAxis: number;
  PotentialAxis: number;
  RatingBandLabel: string;
  PortfolioRevenueActual?: number;
  CategoryScoresJson: string;
  QuantitativeMetricsJson: string;
  ReviewerGroupScoresJson?: string;
  StrengthsJson?: string;
  ImprovementAreasJson?: string;
  ReviewerGroupsSubmitted: number;
  ReviewerGroupsTotal: number;
  IsQuantitativeEligible: boolean;
}

const NINE_BOX_MEDIUM_THRESHOLD = 5.0;
const NINE_BOX_HIGH_THRESHOLD = 7.5;

export const getNineBoxZone = (axis: number): 'low' | 'medium' | 'high' => {
  if (axis >= NINE_BOX_HIGH_THRESHOLD) return 'high';
  if (axis >= NINE_BOX_MEDIUM_THRESHOLD) return 'medium';
  return 'low';
};
